<template>
    <v-toolbar color="primary" fixed dark app>
        <v-toolbar-title class="ml-0">
            <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div style="width:150px">
            <l-select :items="languages"/>
        </div>
        <v-btn icon @click="handleFullScreen()">
            <v-icon>fullscreen</v-icon>
        </v-btn>
        <!-- <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
            <v-btn icon flat slot="activator">
            <v-badge color="red" overlap>
              <span slot="badge">3</span>
              <v-icon medium>notifications</v-icon>
            </v-badge>
            </v-btn>
            <notification-list></notification-list>
        </v-menu>-->
        <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
            <v-btn icon large flat slot="activator">
                <v-avatar size="30px">
                    <v-icon medium>person</v-icon>
                </v-avatar>
            </v-btn>
            <v-list class="pa-0">
                <v-list-tile
                        v-for="(item,index) in items"
                        :to="!item.href ? { name: item.name } : null"
                        :href="item.href"
                        @click="item.click"
                        ripple="ripple"
                        :disabled="item.disabled"
                        :target="item.target"
                        rel="noopener"
                        :key="index"
                >
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
    </v-toolbar>
</template>
<script>
import NotificationList from '../widgets/list/NotificationList'
import toggleFullScreen from '../../helpers/toggleFullScreen'
import LSelect from '../widgets/language/LSelect'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    LSelect
  },
  data () {
    return {
      languages: [
        { flag: 'es', language: 'es', title: 'Español' },
        { flag: 'es-ct', language: 'ca', title: 'Català' },
        { flag: 'gb', language: 'en', title: 'English' }
      ]
    }
  },
  computed: {
    ...mapState({
      profileModalActive: state => state.authentication.profileModalActive
    }),
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav
    },
    items () {
      return [
        {
          icon: 'account_circle',
          title: this.$t('profile'),
          click: e => {
            this.toggleProfileModal()
          }
        },
        {
          icon: 'exit_to_app',
          href: '#',
          title: this.$t('logout'),
          click: e => {
            window.getApp.$emit('APP_LOGOUT')
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      toggleProfileModal: 'authentication/toggleProfileModal'
    }),
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED')
    },
    handleFullScreen () {
      toggleFullScreen()
    }
  }
}
</script>
